module.exports = __webpack_public_path__ + "static/img/78055E_2_3_R_20191024_LC.ed51cb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78055E_2_3_R_20191024_LC.png
// module id = 6odJ
// module chunks = 0